import request from '@/request'

/**
 * 导出QQ数据 无地市处理
 * @returns {AxiosPromise}
 */
export function qq_group_excel(data) {
  return request({
    url: '/api/v1/qq_group_excel',
    method: 'POST',
    data: data,
  })
}

/**
 * 导出QQ数据 地市汇总
 * @returns {AxiosPromise}
 */
export function qq_group_area_excel() {
  return request({
    url: '/api/v1/qq_group_area_data',
    method: 'POST',
  })
}

/**
 * 小工具 格式化excel
 * @param data
 * @returns {AxiosPromise}
 */
export function standard_excel(data) {
  const url = '/api/v1/standard_excel'
  return request({
    url,
    method: 'post',
    responseType: 'blob',
    data: data,
    timeout: 600000,
  })
}
